import React from 'react';
import {Link} from "react-router-dom";

const Error = () => {
    return (
        <div className="bg-gray-100 flex flex-col self-center px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 text-center">
                <div>
                    <h1 className="mt-6 text-9xl font-extrabold text-blue-600">
                        404
                    </h1>
                    <h2 className="mt-2 text-3xl font-bold text-gray-900">
                        Page Not Found
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Oops! The page you're looking for doesn't exist.
                    </p>
                </div>
                <div className="mt-8">
                    <svg className="mx-auto h-12 w-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="mt-1 text-sm text-gray-500">
                        It seems you've taken a wrong turn. Don't worry, it happens to the best of us!
                    </p>
                </div>
                <div className="mt-5 flex justify-center space-x-4">
                    <Link
                        to="/"
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Go to Homepage
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-blue-600 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Error;